export const ASYNC_FETCH = 'ILD_MDNSelection/ASYNC_FETCH';
export const ASYNC_LOAD = 'ILD_MDNSelection/ASYNC_LOAD';
export const ASYNC_FETCH_SUCCESS_ILDDEVICESELECTION = 'ILD_MDNSelection/ASYNC_FETCH_SUCCESS_ILDDEVICESELECTION';
export const ASYNC_FETCH_FAILURE = 'ILD_MDNSelection/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ILD_MDNSelection/ASYNC_FETCH_INVALIDATE';
/**
 * action types
 * @type {string}
 */

export const ASYNC_FETCH_SUCCESS = 'ILD_MDNSelection/ASYNC_FETCH_SUCCESS';
export const DEVICE_COMPATIBLE_CHECK = 'ILD_MDNSelection/DEVICE_COMPATIBLE_CHECK';
export const DEVICE_COMPATIBLE_FLAG = 'ILD_MDNSelection/DEVICE_COMPATIBLE_FLAG';
export const UPDATE_SELECTED_LINE_DETAILS = 'ILD_MDNSelection/UPDATE_SELECTED_LINE_DETAILS';
export const UPDATE_SELECTED_LINE_DETAILS_EFFECTIVE_DATE = 'ILD_MDNSelection/UPDATE_SELECTED_LINE_DETAILS_EFFECTIVE_DATE';
export const EFFECTIVE_DATE_RESPONSE = 'ILD_MDNSelection/EFFECTIVE_DATE_RESPONSE';
export const CLEAR_ALL_LINES = 'ILD_MDNSelection/CLEAR_ALL_LINES';
export const APPLY_TO_ALL_LINES_EFFECTIVE_DATE = 'ILD_MDNSelection/APPLY_TO_ALL_LINES_EFFECTIVE_DATE';
export const UPDATE_GC_PLAN = 'ILD_MDNSelection/UPDATE_GC_PLAN';
export const UPDATE_COUNTRY_LIST = 'ILD_MDNSelection/UPDATE_COUNTRY_LIST';
export const UPDATE_SELECTED_COUNTRY = 'ILD_MDNSelection/UPDATE_SELECTED_COUNTRY';
export const UPDATE_COUNTRY_PRICE = 'ILD_MDNSelection/UPDATE_COUNTRY_PRICE';
export const APPLY_ALL_SELECTED_COUNTRY_DETAILS = 'ILD_MDNSelection/APPLY_ALL_SELECTED_COUNTRY_DETAILS';
export const UPDATED_SUBMITTED_COUNTRIES = 'ILD_MDNSelection/UPDATED_SUBMITTED_COUNTRIES';
export const UPDATE_FRAUD_MODAL_FLAG = 'ILD_MDNSelection/UPDATE_FRAUD_MODAL_FLAG';
export const SET_SELECTED_MDN = 'ILD_MDNSelection/SET_SELECTED_MDN';
export const SET_SELECTED_PLAN = 'ILD_MDNSelection/SET_SELECTED_PLAN';
/**
 * action types
 * @type {string}
 */
// export const formatDate = (val) => {
//     const value = new Date(val);
//     let dd = value.getDate();
//     let mm = value.getMonth() + 1; // January is 0!
//     const yyyy = value.getFullYear();
//     if (dd < 10) {
//         dd = '0' + dd;
//     }
//     if (mm < 10) {
//         mm = '0' + mm;
//     }

//     return mm + '/' + dd + '/' + yyyy;
// };
